import { Button, List, Table } from "antd";
import React from "react";
import { createStructuredSelector } from "reselect";
import { makeSelectIsLoadingSynchronizationErrors, makeSelectSynchronizationErrorsList } from "./selectors";
import { getSynchronizationErrorsWatcher } from "./actions";
import { connect } from "react-redux";
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import saga from "./saga"
import reducer from "./reducer"
import { compose } from "redux";
import "./index.less"
import { Link } from "react-router-dom";
import Loader from "components/Loader"

export class SynchronizationErrors extends React.Component {
    
    componentDidMount() {
        const {
            match: { params },
          } = this.props

        this.props.getSynchronizationErrors(params.id)
    }

    tableColumns() {
        return [
            {
                title: 'Nombre',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Apellidos',
                dataIndex: 'lastName',
                key: 'lastName',
            },
            {
                title: "DNI",
                dataIndex: 'document',
                key: 'document',
            },
            {
                title: "Error",
                dataIndex: 'error',
                key: 'error',
            }
        ]
    }

    showRowItem(item) {
        return (
            <>
                <span>{item.firstName}</span>
                <span>{item.lastName}</span>
                <span>{item.document}</span>
                <span>{item.error}</span>
            </>
        )
    }

    showContent() {
        return (
            <>
                <div className="synchronization-errors-header">
                    <Link to={`/control-panel#synchronization`}>{`< Sincronizaciones`}</Link>
                </div>
                <div className="synchronization-errors-content">
                    <h3 className="synchronization-errors-title">Errores</h3>
                    <div className="synchronization-errors-text">
                        <p>
                            Revisa los errores encontrados durante la sincronización. Realiza las correcciones necesarias en Visma People para garantizar una sincronización exitosa en el próximo intento del sistema.
                        </p>
                        <p>
                            A continuación se presentan los <b>errores encontrados durante la sincronización:</b>  
                        </p>
                    </div>
                    <div className="synchronization-errors-table-wrapper">
                        <List 
                            className="synchronization-errors-table"
                            size="large"
                            loading={this.props.isLoadingSynchronizationErrors}
                            bordered
                            dataSource={this.props.synchronizationErrors}
                            header={
                                <div className="ant-list-header-div" style={{gridTemplateColumns: "1fr 1fr 1fr 1fr"}}>
                                    <span>Nombre</span>
                                    <span>Apellidos</span>
                                    <span>DNI</span>
                                    <span>Error</span>
                                </div>
                            }
                            renderItem={item => {
                                
                                return (
                                    <List.Item>
                                        <div className="ant-list-item-content-div" style={{gridTemplateColumns: "1fr 1fr 1fr 1fr"}}>
                                            {this.showRowItem(item)}
                                        </div>
                                    </List.Item>
                                )
                            }}
                        />
                        <div className="synchronization-errors-table-actions">
                            <Button>
                                <Link to={`/control-panel#synchronization`}>Volver</Link>
                            </Button>
                            <Button type="primary">
                                <a href="https://people.vismalatam.com" target="_blank">Corregir en Visma People</a>
                            </Button>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    render() {
        return (
            <div className="synchronization-errors-container">
              {this.props.isLoadingSynchronizationErrors ? <Loader /> : this.showContent()}  
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    synchronizationErrors: makeSelectSynchronizationErrorsList(),
    isLoadingSynchronizationErrors: makeSelectIsLoadingSynchronizationErrors()
})

function mapDispatchToProps(dispatch) {
    return {
        getSynchronizationErrors: (params) => dispatch(getSynchronizationErrorsWatcher(params))
    }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "synchronizationErrors", reducer })
const withSaga = injectSaga({ key: "synchronizationErrors", saga })

export default compose(withReducer, withSaga, withConnect)(SynchronizationErrors)
